/**
 * @constant 本地icon
 */
export const LOCAL_IMAGES = {
  back_black_icon: require('@/assets/images/common/icon_back_black_arrow.png'),
  back_white_icon: require('@/assets/images/common/icon_back_arrow.png'),
  ding_icon: require('@/assets/images/bill/ding_icon.png'),
  head_tips: require('@/assets/images/bill/head_tips.png'),
  bill_add_icon: require('@/assets/images/bill/bill_add_icon.png'),
  bill_del_sub_icon: require('@/assets/images/bill/bill_del_sub_icon.png'),
  right_arrow_icon: require('@/assets/images/assistant/list_item_right_icon.png'),
  bill_tick_icon: require('@/assets/images/bill/bill_tick_icon.png'),
  tanhao_icon: require('@/assets/images/bill/tanhao_icon.png'),
  bill_empty_icon: require('@/assets/images/bill/bill_empty_icon.png'),
  store_bank_arrow: require('@/assets/images/bill/store_rank_arrow.png'),
  empty_icon: require('@/assets/images/bill/bill_empty_icon.png')
}
// 默认选中全部门店
export const SELECT_ALL_STORE = {
  showName: '所有门店',
  isActiveAll: true,
  storeList: []
}
/**
 * @enum 原开票权限
 */
export const ORIGINAL_INVOICE_PERMISSION_ENUM = {
  unopened: 0, // 未开通
  opened: 1 // 已开通
}
/**
 * @constant 发票状态枚举
 */
export const INVOICE_STATUS_ENUM = {
  all: -1, // 全部
  openWaite: 1, // 开票中
  openSuc: 2, // 开票成功
  openFail: 3, // 开票失败
  redInkWaite: 4, // 红冲中
  redInkSuc: 5, // 红冲成功
  redInkFail: 6 // 红冲失败
}
/**
 * @function 开票状态枚举
 */
export const INVOICE_STATUS_MAP = {
  [INVOICE_STATUS_ENUM.openWaite]: {
    content: '开票中',
    colorStr: '#e6b217',
    operationText: '查看开票码',
    routerName: 'afterOpenInvoice'
  },
  [INVOICE_STATUS_ENUM.openSuc]: {
    content: '开票成功',
    colorStr: '#1bb373',
    operationText: '红冲',
    dialogText: '红冲后发票将冲正，确认红冲'
  },
  [INVOICE_STATUS_ENUM.openFail]: {
    content: '开票失败',
    colorStr: '#f04144',
    operationText: '重开发票',
    routerName: 'openInvoice',
    dialogText: '确认重新开发票'
  },
  [INVOICE_STATUS_ENUM.redInkWaite]: {
    content: '红冲中',
    colorStr: '#e6b217',
    operationText: ''
  },
  [INVOICE_STATUS_ENUM.redInkSuc]: {
    content: '已红冲',
    colorStr: '#818999',
    operationText: '开发票',
    routerName: 'openInvoice',
    dialogText: '确认重新开发票'
  },
  [INVOICE_STATUS_ENUM.redInkFail]: {
    content: '红冲失败',
    colorStr: '#f04144',
    operationText: '继续红冲',
    dialogText: '确认继续红冲'
  }
}
/**
 * @constant 发票状态
 */
export const INVOICE_STATUS_LIST = [
  {
    label: '全部',
    value: INVOICE_STATUS_ENUM.all
  },
  {
    label: '开票成功',
    value: INVOICE_STATUS_ENUM.openSuc
  },
  {
    label: '开票失败',
    value: INVOICE_STATUS_ENUM.openFail
  },
  {
    label: '开票中',
    value: INVOICE_STATUS_ENUM.openWaite
  },
  {
    label: '已红冲',
    value: INVOICE_STATUS_ENUM.redInkSuc
  },
  {
    label: '红冲中',
    value: INVOICE_STATUS_ENUM.redInkWaite
  },
  {
    label: '红冲失败',
    value: INVOICE_STATUS_ENUM.redInkFail
  }
]
/**
 * @constant 弹窗类型
 */
export const DIALOG_TYPE = {
  num: 1, // 开票数
  amount: 2 // 开票金额
}
/**
 * @constant 列表页汇总展示文案
 */
export const DIALOG_CONTENT = {
  [DIALOG_TYPE.num]: '已成功开票张数(不包含开票中和开票失败，若发票已红冲也会相应扣减)',
  [DIALOG_TYPE.amount]: '已成功开票金额(不包含开票中和开票失败，若发票已红冲也会相应扣减)'
}
/**
 * @constant 详情展示字段
 */
export const DETAIL_LIST = [
  {
    title: '开票门店',
    val: 'storeName'
  },
  {
    title: '开票人',
    val: 'operator'
  },
  {
    title: '开票时间',
    val: 'createTime'
  },
  {
    title: '开票日期',
    val: 'invoiceDate'
  },
  {
    title: '发票号码',
    val: 'invoiceNo'
  },
  {
    title: '发票类型',
    val: 'invoiceTypeName'
  },
  {
    title: '购方名称',
    val: 'buyerName'
  },
  {
    title: '购方手机号',
    val: 'buyerPhone'
  },
  {
    title: '购方邮箱',
    val: 'buyerMail'
  },
  {
    title: '开票来源',
    val: 'invoiceSource'
  },
  {
    title: '备注',
    val: 'invoiceRemark'
  }

]
/**
 * @constant pos详情展示字段
 */
export const POS_DETAIL_LIST = [
  {
    title: '付呗订单号',
    val: 'orderSn'
  },
  {
    title: '设备SN',
    val: 'deviceSn'
  }
]
/**
 * @constan 开票来源
 */
export const INVOICE_SOURCE = {
  pos: 1, // pos
  app: 2 // 付呗app
}
/**
 * @constant 来源文案
 */
export const INVOICE_SOURCE_TEXT = {
  [INVOICE_SOURCE.app]: '付呗APP',
  [INVOICE_SOURCE.pos]: 'POS'
}
/**
 * @constant 默认页码
 */
export const PAGE_DEFAULT = 1
/**
 * @constantt router name
 */
export const PAGE_ROUTER_NAME = {
  selectStore: 'invoiceSelectStore', // 选择门店
  selectSingleStore: 'invoiceSelectSingleStore' // 选择单个门店
}
/**
 * @function 开票来源文案
 */
export const FROM_SOURCE_TEXT = '开票来源'
